<dialog class="t-rating-dialog w-[50%] p-5 rounded-lg  bg-white shadow border border-neutral-300" #dialog role="dialog" aria-labelledby="rating-title" *transloco="let t; prefix: 'rating'">
   <button class="float-end ms-2" (click)="cancel()" [attr.aria-label]="t('close.dialog')">
      <svg aria-hidden="true" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
         <g clip-path="url(#clip0_2589_1608)">
            <path d="M19 6.84533L17.59 5.43533L12 11.0253L6.41 5.43533L5 6.84533L10.59 12.4353L5 18.0253L6.41 19.4353L12 13.8453L17.59 19.4353L19 18.0253L13.41 12.4353L19 6.84533Z" fill="#828282"/>
         </g>
         <defs>
         <clipPath id="clip0_2589_1608">
            <rect width="24" height="24" fill="white" transform="translate(0 0.435333)"/>
         </clipPath>
         </defs>
      </svg>
   </button>
   <h2 class="text-xl font-bold" id="rating-title">{{ t('title') }}</h2>
   @if(feedback?.reaction === 'thumbs_up') {
      <div class="my-4">{{ t('helptext.whygood', {typeLocalization}) }}</div>
      <form [formGroup]="feedbackGood" class="t-rating-reasons flex flex-col gap-2">
         <label *ngFor="let option of feedbackGoodOptions[type]">
            <input class="me-1" type="checkbox" [value]="option.value"
               (change)="onCheckboxChange($event, feedbackGoodReasons!)" required>
            <span>{{ t(option.text) }}</span>
         </label>
         <div class="mt-4">{{ t('helptext.explain', {typeLocalization}) }}</div>
         <textarea class="t-rating-comments p-2 w-full h-24 mt-2 border border-zinc-400"
            [attr.placeholder]="t('nopersonalinfo')" formControlName="comment"></textarea>
      </form>
   }
   @else if(feedback?.reaction === 'thumbs_down') {
      <div class="my-4">{{ t('helptext.whybad', {typeLocalization}) }}</div>
      <form [formGroup]="feedbackBad" class="t-rating-reasons flex flex-col gap-2">
         <label *ngFor="let option of feedbackBadOptions[type]">
            <input class="me-1" type="checkbox" [value]="option.value"
               (change)="onCheckboxChange($event, feedbackBadReasons!)" required>
            <span>{{ t(option.text) }}</span>
         </label>
         <div class="mt-4">{{ t('helptext.explain', {typeLocalization}) }}</div>
         <textarea class="t-rating-comments p-2 w-full h-24 mt-2 border border-zinc-400"
            [attr.placeholder]="t('nopersonalinfo')" formControlName="comment"></textarea>
      </form>
   }

   <div class="flex flex-row gap-2 mt-4">
      <button class="t-rating-submit p-2 bg-cdra-blue-light-main rounded" (click)="submit()" [disabled]="isFormInvalid()" >
         <div class="text-white text font-normal leading-tight">{{ t('submit') }}</div>
      </button>
      <button class="t-rating-cancel p-2 bg-zinc-300 rounded border border-zinc-400" (click)="cancel()">
         <div class="text-black font-normal leading-tight">{{ t('cancel') }}</div>
      </button>
   </div>

   <br>
   <div class="mt-4-italic"><i>{{ t('helptext.terms', {typeLocalization}) }}</i></div>

</dialog>